module.exports = __webpack_public_path__ + "img/upgrade_normal_icon.714d8e28.svg";